import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const EditDoctor = () => {
  const { auth } = useAuth();
  const { state } = useLocation();
  const [alert, setAlert] = useState(state ? state : null);
  const [values, setValues] = useState({});
  const [file, setFile] = useState(null);
  const [img, setImg] = useState();

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [education, setEducation] = useState({});
  const [experience, setExperience] = useState({});

  const positionRef = useRef(null);
  const companyRef = useRef(null);
  const expYearRef = useRef(null);
  const degreeRef = useRef(null);
  const universityRef = useRef(null);
  const eduYearRef = useRef(null);

  const { id } = useParams();

  useEffect(() => {
    let timeoutId = setTimeout(() => {
      setAlert(null);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const onChange = (e) => {
    // stores the name from where event was received
    const name = e.target.name;
    const value = e.target.value;
    //checks the name of the event and processed accordingly
    if (name === "name" || name === "email") {
      setValues({
        ...values,
        user_detail: { ...values.user_detail, [name]: value },
      });
    } else if (name === "user_image") {
      setFile({ image: e.target.files });
      //retrieves the selected file
      const image = e.target.files[0];
      //reads the content of the file
      const reader = new FileReader();
      //updates the state with the url of image
      reader.onloadend = () => {
        setImg(reader.result);
      };
      reader.readAsDataURL(image);
    } else if (
      name === "position" ||
      name === "company" ||
      name === "experience_year"
    ) {
      if (name === "experience_year") {
        setExperience({ ...experience, year: value });
      } else {
        setExperience({ ...experience, [name]: value });
      }
    } else if (
      name === "degree" ||
      name === "university" ||
      name === "education_year"
    ) {
      if (name === "education_year") {
        setEducation({ ...education, year: value });
      } else {
        setEducation({ ...education, [name]: value });
      }
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const clickExperience = (e) => {
    //resetting input field to null
    positionRef.current.value = "";
    companyRef.current.value = "";
    expYearRef.current.value = "";

    //alerts if fields are null else sets Values
    experience["position"] === undefined ||
    experience["company"] === undefined ||
    experience["year"] === undefined
      ? showAlert("Fill all the fields.", "warning")
      : setValues({
          ...values,
          experience: [
            ...values.experience,
            { ...experience, doctor: values.id },
          ],
        });
    setExperience({});
  };

  const clickEducation = (e) => {
    //resetting input field to null
    degreeRef.current.value = "";
    universityRef.current.value = "";
    eduYearRef.current.value = "";

    //alerts if fields are null else sets Values
    education["degree"] === undefined ||
    education["university"] === undefined ||
    education["year"] === undefined
      ? showAlert("Fill all the fields.", "warning")
      : setValues({
          ...values,
          education: [...values.education, { ...education, doctor: values.id }],
        });
    setEducation({});
  };

  const onDelete = (id, str) => {
    //checks from which button delete is called
    if (str === "exp") {
      //gets the value except for the passed id
      const updatedValue = values.experience.filter((value) => value.id !== id);
      //sets new remaining values to state
      setValues({
        ...values,
        experience: updatedValue,
      });
    } else if (str === "edu") {
      //gets the value except for the passed id
      const updatedValue = values.education.filter((value) => value.id !== id);
      //sets new remaining values to state
      setValues({
        ...values,
        education: updatedValue,
      });
    }
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axiosPrivate.get(`user/doctor/${id}`);
        setValues(response.data);
        setImg(response?.data.user_detail.user_image);
      } catch (err) {
        showAlert("Doctor not found.", "warning");
      }
    }
    fetchData();
  }, []);

  const submit = async (e) => {
    if (
      !file &&
      values?.user_detail?.user_image?.split("/").pop === "default.png"
    ) {
      showAlert("Upload Image.", "warning");
    } else {
      try {
        const formData = new FormData();
        delete values.user_detail.user_image;
        await axiosPrivate.put(`user/doctor/${id}/`, JSON.stringify(values));

        //file is appended after checking its existence
        if (file !== null) {
          formData.append("user_image", file.image[0]);
          await axiosPrivate.put(`user/doctor/image/${id}/`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        }
        if (auth?.user.roles === 0) {
          navigate("/doctor/list", {
            state: {
              message: "Profile Updated.",
              type: "success",
            },
          });
        } else if (auth?.user.roles === 1) {
          navigate("/list/appointment", {
            state: {
              message: "Profile Updated.",
              type: "success",
            },
          });
        }
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else {
          showAlert("Update Failed", "warning");
        }
      }
    }
  };

  return (
    <div>
      <AlertField alert={alert} />
      {values?.id ? (
        <div>
          <h2 className="text-center py-3">Edit Doctor Profile</h2>
          <div className="row row-cols-2 mx-5 px-5">
            <div
              className="col py-4 px-5 bg-light"
              style={{ borderRight: "4px solid white" }}
            >
              <div>
                <h4>Profile</h4>
                <div className="d-flex justify-content-between">
                  <table className="table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td>
                          <h6 className="mx-1">Name</h6>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="name"
                            id="name"
                            value={values?.user_detail["name"] || ""}
                            onChange={onChange}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h6 className="mx-1">Email</h6>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="email"
                            id="email"
                            value={values?.user_detail.email || ""}
                            onChange={onChange}
                            disabled
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <h6 className="mx-1">Specialization</h6>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="specialization"
                            id="specialization"
                            value={values?.specialization || ""}
                            onChange={onChange}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="d-flex flex-column align-items-center position-relative">
                    <img
                      src={img && img}
                      alt="doctor"
                      className="bg-white border border-dark rounded-circle"
                      width={150}
                      height={150}
                    />

                    <div className="position-absolute bottom-0 end-0 rounded-circle bg-secondary">
                      <label htmlFor="formFileSm" className="m-0">
                        <i className="fas fa-camera fs-4 btn text-dark p-2"></i>
                      </label>
                      <input
                        className="d-none"
                        id="formFileSm"
                        type="file"
                        name="user_image"
                        accept="image/png, image/jpeg"
                        placeholder="Image"
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="my-4">
                  <h4>Experience</h4>
                  <input
                    className="w-5 mx-2 px-2"
                    style={{ width: 8 + "rem" }}
                    type="text"
                    name="position"
                    id="position"
                    placeholder="Position"
                    onChange={onChange}
                    ref={positionRef}
                  />
                  <input
                    className="w-5 mx-2 px-2"
                    style={{ width: 8 + "rem" }}
                    type="text"
                    name="company"
                    id="company"
                    placeholder="Company"
                    onChange={onChange}
                    ref={companyRef}
                  />
                  <input
                    className="w-5 mx-2 px-2"
                    style={{ width: 8 + "rem" }}
                    type="text"
                    name="experience_year"
                    id="experience_year"
                    placeholder="Year"
                    onChange={onChange}
                    ref={expYearRef}
                  />
                  <button className="btn mb-1" onClick={clickExperience}>
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                <div className="my-4">
                  <h4>Education</h4>
                  <input
                    className="w-5 mx-2 px-2"
                    style={{ width: 8 + "rem" }}
                    type="text"
                    name="degree"
                    id="degree"
                    placeholder="Degree"
                    onChange={onChange}
                    ref={degreeRef}
                  />
                  <input
                    className="w-5 mx-2 px-2"
                    style={{ width: 8 + "rem" }}
                    type="text"
                    name="university"
                    id="university"
                    placeholder="University"
                    onChange={onChange}
                    ref={universityRef}
                  />
                  <input
                    className="w-5 mx-2 px-2"
                    style={{ width: 8 + "rem" }}
                    type="text"
                    name="education_year"
                    id="education_year"
                    placeholder="Year"
                    onChange={onChange}
                    ref={eduYearRef}
                  />
                  <button className="btn mb-1" onClick={clickEducation}>
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
                {auth?.user?.roles === 0 && (
                  <div className="d-flex mt-4">
                    <h4>Fee</h4>
                    <input
                      className="w-5 px-2 mx-3"
                      style={{ width: 8 + "rem" }}
                      type="number"
                      name="fees"
                      id="fees"
                      placeholder="Fee"
                      value={values?.fees}
                      onChange={onChange}
                    />
                  </div>
                )}
              </div>
            </div>
            <div
              className="col px-4 bg-light text-capitalize position-relative"
              style={{ borderLeft: "4px solid white" }}
            >
              <section className="rounded-3 border my-3 p-2">
                <h4>Experience</h4>
                <div className="overflow-auto" style={{ height: 6 + "rem" }}>
                  <table className="table table-borderless">
                    <tbody>
                      {values?.experience.map((experience, i) => (
                        <tr key={i}>
                          <td>{i + 1}.</td>
                          <td>{experience.company}</td>
                          <td>{experience.position}</td>
                          <td>
                            {experience.year}
                            <button
                              className="btn border-0 p-0 mx-1 mb-1"
                              onClick={() => onDelete(experience.id, "exp")}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ fill: "red" }}
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                className="hover"
                              >
                                <path d="M5.72 5.72a.75.75 0 0 1 1.06 0L12 10.94l5.22-5.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L13.06 12l5.22 5.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 13.06l-5.22 5.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.94 12 5.72 6.78a.75.75 0 0 1 0-1.06Z"></path>
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
              <section className="rounded-3 border my-3 p-2">
                <h4>Education</h4>
                <div className="overflow-auto" style={{ height: 6 + "rem" }}>
                  <table className="table table-borderless">
                    <tbody>
                      {values?.education.map((education, i) => (
                        <tr key={i}>
                          <td>{i + 1}.</td>
                          <td>{education.degree}</td>
                          <td>{education.university}</td>
                          <td>
                            {education.year}
                            <button
                              className="btn border-0 p-0 mx-1 mb-1"
                              onClick={() => onDelete(education.id, "edu")}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ fill: "red" }}
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                              >
                                <path d="M5.72 5.72a.75.75 0 0 1 1.06 0L12 10.94l5.22-5.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L13.06 12l5.22 5.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 13.06l-5.22 5.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.94 12 5.72 6.78a.75.75 0 0 1 0-1.06Z"></path>
                              </svg>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
              {auth?.user?.roles === 0 && (
                <div className="mt-4 align-items-center">
                  <h5 className="me-4">Description</h5>
                  <textarea
                    className="w-100 px-2"
                    name="description"
                    rows={3}
                    onChange={onChange}
                    value={values?.description}
                  ></textarea>
                </div>
              )}
              <div className={`w-100 text-center ${auth?.user.roles === 1 && "position-absolute"} bottom-0 mb-2`}>
                <button className="btn btn-primary mb-1 px-5" onClick={submit}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>No Doctor</p>
      )}
    </div>
  );
};

export default EditDoctor;
